/**
 * Simple hash-based router — no external library needed.
 * Routes: #/overview, #/tenants, #/subscriptions, #/publishing,
 *         #/workers, #/metrics, #/search, #/audit-log, #/providers, #/notifications
 */

export type OpsRoute =
  | "overview"
  | "tenants"
  | "subscriptions"
  | "publishing"
  | "workers"
  | "metrics"
  | "search"
  | "audit-log"
  | "providers"
  | "notifications";

const VALID_ROUTES: OpsRoute[] = [
  "overview", "tenants", "subscriptions", "publishing",
  "workers", "metrics", "search", "audit-log", "providers", "notifications",
];

export function getCurrentRoute(): OpsRoute {
  const hash = window.location.hash.replace(/^#\/?/, "");
  const route = hash.split("?")[0] as OpsRoute;
  return VALID_ROUTES.includes(route) ? route : "overview";
}

export function navigate(route: OpsRoute): void {
  window.location.hash = `/${route}`;
}

export function useRoute(): OpsRoute {
  // Caller must re-read on hashchange — handled in App via state
  return getCurrentRoute();
}
